// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"_1Juq_","counter":"Iexl7","anchor":"_1buk6","nextbutton":"_3r9YD"};


/*****************
 ** WEBPACK FOOTER
 ** ./src/components/Page/PageComponents/InfoQuiz/Quiz.scss
 ** module id = 455
 ** module chunks = 0
 **/